import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CandidateModel } from 'app/interfaces';

@Component({
  selector: 'app-candidate-section',
  templateUrl: './candidate-section.component.html',
  styleUrls: ['./candidate-section.component.scss']
})
export class CandidateSectionComponent implements OnInit {
  @Input('candidate') inputCandidate: CandidateModel = null;
  @Input() index: number = null;
  @Input() isExternal: boolean = false;
  @Input() showPersonalInfo: boolean = false;
  @Output() onClick: EventEmitter<any> = new EventEmitter<any>();

  public candidate: CandidateModel;
  constructor() { }

  ngOnInit() {
    this.candidate = new CandidateModel(this.inputCandidate);
  }

}
